<template>
    <div class="reg-temp-content-area main-content-height p-3">
        <div class="superadmin-dashboard-area edit-area">
            <div class="row" v-if="loadStatus == 0">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    <loading />
                </div>
            </div>

            <div class="row" v-else>
                <div class="col-sm-12 col-md-7 col-lg-8">
                    <div class="card mb-4">
                        <div class="card-body">
                            <div :class="'registered-product-item ' + (vg_loggedIn_user_id == product_detail.owner_id ? 'mine' : 'mine')">
                                <router-link :to="{name: 'ResellerRegisteredProducts'}" class="mb-3 inline-block"
                                    ><i class="fas fa-long-arrow-alt-left"></i> Back</router-link
                                >
                                <h3 class="mb-4">Product Details</h3>
                                <ul>
                                    <serial-and-model :data="form" />
                                    <li>
                                        <span class="semibold">Date purchased</span>
                                        <span>
                                            <vuejs-datepicker
                                                initial-view="year"
                                                maximum-view="year"
                                                v-model="form.date_of_purchase"
                                                :typeable="false"
                                                :full-month-name="true"
                                                :format="'yyyy-MM-dd'"
                                                class="input"
                                                id="purchased_date"
                                                placeholder="YYYY-MM-DD"
                                                :disabled-dates="purchaseDisabledDates"
                                            ></vuejs-datepicker>
                                        </span>
                                    </li>

                                    <li>
                                        <span class="semibold">Installation date</span>
                                        <span>
                                            <vuejs-datepicker
                                                initial-view="year"
                                                maximum-view="year"
                                                v-model="form.installation_date"
                                                :typeable="false"
                                                :full-month-name="true"
                                                :format="'yyyy-MM-dd'"
                                                class="input"
                                                id="install_date"
                                                placeholder="YYYY-MM-DD"
                                                :disabled-dates="installationDisabledDates"
                                            ></vuejs-datepicker>
                                        </span>
                                    </li>
                                    <li>
                                        <span class="semibold">Place of purchase</span>
                                        <span><input type="text" v-model="form.place_of_purchase" /></span>
                                    </li>
                                    <li class="border-b-1">
                                        <file-uploader label="Upload proof of purchase" id="proof_of_purchase" :form.sync="form" />
                                    </li>

                                    <li>
                                        <span class="semibold">Installation status</span>
                                        <span class="mt-1 coc-radio d-flex flex-column cursor-pointer">
                                            <label class="mr-2 font-normal" for="with_coc">
                                                <input
                                                    id="with_coc"
                                                    type="radio"
                                                    class="w-auto"
                                                    v-model="form.installation_compliance"
                                                    value="with_coc"
                                                />
                                                Installed with COC
                                            </label>
                                            <label class="mr-2 font-normal" for="without_coc">
                                                <input
                                                    id="without_coc"
                                                    type="radio"
                                                    class="w-auto"
                                                    v-model="form.installation_compliance"
                                                    value="without_coc"
                                                />
                                                Installation delayed
                                            </label>
                                            <label class="mr-2 font-normal" for="no_coc">
                                                <input
                                                    id="no_coc"
                                                    type="radio"
                                                    class="w-auto"
                                                    v-model="form.installation_compliance"
                                                    value="no_coc"
                                                />
                                                No COC
                                            </label>
                                        </span>
                                    </li>
                                    <div v-show="form.installation_compliance == 'with_coc'">
                                        <li>
                                            <span class="semibold">Coc number</span> <span> <input type="text" v-model="form.coc_number" /></span>
                                        </li>
                                        <li>
                                            <file-uploader label="Upload coc certificate" id="coc_certificate" :form.sync="form" />
                                        </li>
                                    </div>
                                </ul>
                                <button class="btn btn-primary mt-3" @click.prevent="updateRegProduct()">Submit</button>
                            </div>

                            <ticket-box
                                class="mt-4"
                                :ticket_status="ticket_status"
                                :ticket_type="ticket_type"
                                :tickets="ticketMessages"
                                :form="form"
                            />
                        </div>
                    </div>
                </div>

                <div class="col-sm-12 col-md-5 col-lg-4">
                    <div class="card">
                        <div class="card-body">
                            <div class="change-product-seller">
                                <h5 class="mb-0">DEPOT</h5>
                                <h3>
                                    <span class="focus-primary" v-if="isEmpty(distributorObj) == false">{{
                                        distributorObj ? distributorObj.company : '-----'
                                    }}</span>
                                </h3>
                                <p v-if="isEmpty(distributorObj) == false">
                                    {{ distributorObj.fname ? distributorObj.fname + ' ' + distributorObj.lname : '' }} <br />
                                    {{ distributorObj.email ? distributorObj.email : '' }} <br />
                                    {{ distributorObj.company ? distributorObj.company : '' }} <br />
                                    {{ distributorObj.mobile ? distributorObj.mobile : '' }}
                                </p>

                                <p class="mb-0"><small class="color-blue">Please select value from suggestion</small></p>
                                <vue-autosuggest
                                    :suggestions="purchasedFromSuggestions"
                                    :input-props="{class: 'form-control', id: 'autosuggest_purchasedfrom_input', placeholder: 'Change Depot'}"
                                    @input="onChangePurchasedFrom"
                                    @selected="selectPurchasedFromHandler"
                                    @click="onChangePurchasedFrom"
                                    :getSuggestionValue="purchasedFromSuggestionsValue"
                                >
                                    <template slot-scope="{suggestion}">
                                        <span class="my-suggestion-item">{{
                                            suggestion.item.fname ? suggestion.item.company : suggestion.item.email
                                        }}</span>
                                    </template>
                                </vue-autosuggest>
                                <button class="btn btn-primary mt-3" @click.prevent="updatePurchasedFrom()">Update</button>
                            </div>
                        </div>
                    </div>

                    <div class="card mt-5">
                        <div class="card-body">
                            <div class="change-product-seller">
                                <h5 class="mb-0">CUSTOMER</h5>
                                <h3>
                                    <span class="focus-primary" v-if="isEmpty(customerObj) == false">{{
                                        customerObj ? customerObj.company : '-----'
                                    }}</span>
                                </h3>
                                <p v-if="isEmpty(customerObj) == false">
                                    {{ customerObj.fname ? customerObj.fname + ' ' + customerObj.lname : '' }} <br />
                                    {{ customerObj.email ? customerObj.email : '' }} <br />
                                    {{ customerObj.mobile ? customerObj.mobile : '' }}
                                </p>
                                <p class="mb-0"><small class="color-blue">Please select value from suggestion</small></p>
                                <vue-autosuggest
                                    :suggestions="soldToSuggestions"
                                    :input-props="{class: 'form-control', id: 'autosuggest_soldto_input', placeholder: 'Change Customer'}"
                                    @input="onChangeSoldTo"
                                    @selected="selectSoldToHandler"
                                    @click="onChangeSoldTo"
                                    :getSuggestionValue="soldToSuggestionsValue"
                                >
                                    <template slot-scope="{suggestion}">
                                        <span class="my-suggestion-item">{{ suggestion.item.fname + ' ' + suggestion.item.lname }}</span>
                                    </template>
                                </vue-autosuggest>
                                <button class="btn btn-primary mt-3" @click.prevent="updateSoldTo()">Update</button>
                                <p class="mt-3">
                                    <em
                                        >Can't find ?
                                        <router-link
                                            :to="{name: 'ResellerCustomersAdd', query: {redirect: 'ResellerRegisteredProductEdit'}}"
                                            target="_blank"
                                            >Add new customer</router-link
                                        ></em
                                    >
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import Env from '@/env';
import AuthApis from '@/controllers/AuthApis';
import Helpers from '@/helpers/index';
import {VueAutosuggest} from 'vue-autosuggest';
import * as _ from 'lodash';
import TicketBox from '@/components/WarrantyRepairBox.vue';
import moment from 'moment';
import bus from '@/bus';

export default {
    components: {
        VueAutosuggest,
        TicketBox
    },
    name: 'customerRegProductEdit',
    data() {
        return {
            subscribedChannel: false,
            loadCount: 0,
            loadStatus: 0,
            loaded: false,
            ticketMessages: [],

            distributorObj: {},
            purchasedFromSuggestions: [
                {
                    data: []
                }
            ],

            customerObj: {},
            soldToSuggestions: [
                {
                    data: []
                }
            ],

            coc_certificate_change: '',
            form: {
                id: '',
                hasOrderNumber: false,
                product_model: '',
                serial_number: '',
                sku_number: '',
                order_number: '',
                sku_with_serial_number: '',
                place_of_purchase: '',
                date_of_purchase: '',
                installation_date: '',
                installation_compliance: 'with_coc',
                coc_number: '',
                coc_certificate_path: '',
                coc_certificate: {
                    url: '',
                    name: '',
                    type: '',
                    size: ''
                },
                invoice_number: '',
                distributor_id: '',
                customer_id: '',
                open_ticket_request: false,
                has_open_ticket: false,
                proof_of_purchase: {
                    incoming_url: '',
                    url: '',
                    file: '',
                    name: '',
                    type: '',
                    size: ''
                },
                ticket_status: '',
                ticket_type: ''
            },
            product_detail: {}
        };
    },

    watch: {
        'form.purchased_from_role'() {
            this.form.purchased_from = '';
        }
        // 'form.date_of_purchase': {
        //     handler(newVal) {
        //         if (this.form.installation_date && newVal && this.form.installation_date < newVal) {
        //             this.form.installation_date = null;
        //         } else if (this.form.installation_date && !newVal) {
        //             this.form.installation_date = null;
        //         }
        //     },
        //     deep: true
        // },
        // 'form.installation_date': {
        //     handler(newVal) {
        //         if (this.form.date_of_purchase && newVal && this.form.date_of_purchase > newVal) {
        //             this.form.date_of_purchase = null;
        //         } else if (this.form.date_of_purchase && !newVal) {
        //             this.form.date_of_purchase = null;
        //         }
        //     },
        //     deep: true
        // }
    },

    computed: {
        purchaseDisabledDates() {
            let disabled = {from: new Date()};
            if (this.form.installation_date) {
                const dayAfterInstall = new Date(this.form.installation_date);
                dayAfterInstall.setDate(dayAfterInstall.getDate());
                disabled.from = dayAfterInstall;
            }
            return disabled;
        },
        installationDisabledDates() {
            let disabled = {from: new Date()};

            if (this.form.date_of_purchase) {
                const dayBeforePurchase = new Date(this.form.date_of_purchase);
                dayBeforePurchase.setDate(dayBeforePurchase.getDate());
                disabled.to = dayBeforePurchase;
            }

            return disabled;
        },
        ...mapGetters({
            vg_loggedIn_user_id: 'auth/userid'
        })
    },

    async mounted() {
        let res = await this.fetchProductDetail();
        if (res) {
            this.subscribeProductChannel(res);
        }
        bus.$on('warranty-repair-box-refetch', () => {
            this.fetchProductDetail();
        });
    },
    methods: {
        /**
         * subscribe pubnub
         */
        async subscribeProductChannel(res) {
            const self = this;

            if (this.subscribedChannel == false) {
                let channels = [];
                channels.push(res.sku_with_serial_number);
                this.$pnSubscribe({channels: channels});
                this.$pnGetMessage(res.sku_with_serial_number, this.receiveEmit);
                this.subscribedChannel == true;
            }
        },

        receiveEmit(emit) {
            this.fetchProductDetail();
        },

        /**
         * Fle handling
         */
        async fileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }
            // file type cehck
            if (this.$refs.coc_certificate.files[0].type != 'application/pdf') {
                document.getElementById('coc_certificate').value = '';
                this.$toasted.global.error({
                    message: 'Only pdf files are allowed.'
                });
                return;
            }

            // filesize prevent
            let limit5Mb = 5 * 1000000; // 5 MB limit
            if (this.$refs.coc_certificate.files[0].size > limit5Mb) {
                document.getElementById('coc_certificate').value = '';
                this.snackbar({
                    message: 'Sorry file cannot be more than 5MB.',
                    type: 'warning'
                });
                return;
            }

            this.form.coc_certificate = {
                url: URL.createObjectURL(files[0]),
                file: files[0],
                name: this.$refs.coc_certificate.files[0].name,
                type: this.$refs.coc_certificate.files[0].type,
                size: this.$refs.coc_certificate.files[0].size
            };
        },

        /**
         * Update updatePurchasedFrom
         */
        async updatePurchasedFrom() {
            if (_.isEmpty(this.distributorObj)) {
                return this.$toasted.global.error({
                    message: 'Please select Depot.'
                });
            }

            const url = `${Env.baseUrl}/reseller/reg-product/update/purchased-from/${this.$route.params.id}`;
            AuthApis.postApi(url, {purchased_from: this.distributorObj.id})
                .then((res) => {
                    this.$toasted.global.success({
                        message: 'Successfully updated.'
                    });
                })
                .catch((err) => {
                    this.$toasted.global.error({
                        message: err.response.data.errors[0]
                    });
                });
        },

        /**
         * Update updatePurchasedFrom
         */
        async updateSoldTo() {
            if (_.isEmpty(this.customerObj)) {
                return this.$toasted.global.error({
                    message: 'Please select Customer.'
                });
            }

            const url = `${Env.baseUrl}/reseller/reg-product/update/sold-to/${this.$route.params.id}`;
            AuthApis.postApi(url, {sold_to: this.customerObj.id})
                .then((res) => {
                    this.$toasted.global.success({
                        message: 'Successfully updated.'
                    });
                })
                .catch((err) => {
                    this.$toasted.global.error({
                        message: err.response.data.errors[0]
                    });
                });
        },

        /**
         * Update
         */
        updateRegProduct() {
            this.form.sku_with_serial_number = Helpers.getFullSerialNumber(this.form);
            this.form.installation_date = this.form.installation_date ? moment(this.form.installation_date).format('YYYY-MM-DD') : '';
            this.form.date_of_purchase = this.form.date_of_purchase ? moment(this.form.date_of_purchase).format('YYYY-MM-DD') : '';

            if (this.form.date_of_purchase && this.form.installation_date && this.form.installation_date < this.form.date_of_purchase) {
                return this.$toasted.global.error({
                    message: 'Installation date cannot be before date of purchase.'
                });
            }

            let formData = new FormData();
            for (let key in this.form) {
                if (key != 'coc_certificate' && key != 'proof_of_purchase') {
                    formData.append(key, this.form[key]);
                }
            }

            if (this.form.coc_certificate.file) {
                // uploadd file to server
                formData.append('coc_certificate', this.form.coc_certificate.file);
            } else if (this.form.coc_certificate.incoming_url == '') {
                // pass blank value to server
                formData.append('coc_certificate', '');
            }

            if (this.form.proof_of_purchase.file) {
                // uploadd file to server
                formData.append('proof_of_purchase', this.form.proof_of_purchase.file);
            } else if (this.form.proof_of_purchase.incoming_url == '') {
                // pass blank value to server
                formData.append('proof_of_purchase', '');
            }

            const url = `${Env.baseUrl}/reseller/reg-product/update/${this.form.id}`;
            this.spinner(true);
            AuthApis.postApi(url, formData)
                .then((res) => {
                    this.spinner(false);
                    this.$toasted.global.success({
                        message: 'Successfully updated.'
                    });
                })
                .catch((err) => {
                    this.spinner(false);
                    this.$toasted.global.error({
                        message: err.response.data.errors[0]
                    });
                });
        },

        /**
         * Fetch product detail
         */
        async fetchProductDetail() {
            this.loaded = false;
            const url = `${Env.baseUrl}/reseller/reg-product/show/${this.$route.params.id}`;
            return AuthApis.getApi(url)
                .then(async (res) => {
                    this.ticketMessages = res.data.payload.tickets ? res.data.payload.tickets : [];
                    this.ticket_status = res.data.payload.ticket_status;
                    this.ticket_type = res.data.payload.ticket_type;

                    this.product_detail = res.data.payload;
                    this.form.id = res.data.payload.id;
                    this.form.product_model = res.data.payload.sku_number;
                    this.form.serial_number = res.data.payload.serial_number;
                    this.form.sku_number = res.data.payload.sku_number;
                    this.form.order_number = res.data.payload.order_number;
                    this.form.hasOrderNumber = res.data.payload.order_number ? true : false;

                    this.form.date_of_purchase = res.data.payload.date_of_purchase;
                    this.form.installation_date = res.data.payload.installation_date;
                    this.form.place_of_purchase = res.data.payload.place_of_purchase;
                    this.form.coc_number = res.data.payload.coc_number;

                    this.form.proof_of_purchase.incoming_url = res.data.payload.proof_of_purchase;
                    this.form.coc_certificate.incoming_url = res.data.payload.coc_certificate;

                    this.form.installation_compliance = res.data.payload.installation_compliance
                        ? res.data.payload.installation_compliance
                        : 'no_coc';

                    // Sold to
                    this.form.customer_id = res.data.payload.customer ? res.data.payload.customer.id : '';
                    this.customerObj = res.data.payload.customer ? res.data.payload.customer : {};

                    this.form.distributor_id = res.data.payload.distributor_id ? res.data.payload.distributor.id : '';
                    this.distributorObj = res.data.payload.distributor;

                    if (this.loadStatus == 0) {
                        this.loadStatus = 1;
                    }

                    this.$nextTick(() => {
                        var messageDiv = document.getElementById('display_messages');
                        if (messageDiv) {
                            messageDiv.scrollTop = messageDiv.scrollHeight;
                        }
                    });
                    this.loaded = true;
                    return res.data.payload;
                })
                .catch((err) => {
                    console.log(err);
                    this.loaded = true;
                    return false;
                });
        },

        /**
         *
         * On change serach reftch suggest
         */
        onChangePurchasedFrom: _.debounce(function (company) {
            this.form.distributor_id = '';
            const url = `${Env.baseUrl}/reseller/seller/suggest`;
            AuthApis.postApi(url, {
                name: company
            })
                .then((res) => {
                    this.purchasedFromSuggestions[0].data = res.data.payload;
                })
                .catch((err) => {
                    console.log(err);
                });
        }, 800),

        /**
         *
         * On change serach reftch suggest
         */
        onChangeSoldTo: _.debounce(function (company) {
            this.form.distributor_id = '';
            const url = `${Env.baseUrl}/reseller/customers/suggest`;
            AuthApis.postApi(url, {
                name: company
            })
                .then((res) => {
                    this.soldToSuggestions[0].data = res.data.payload;
                })
                .catch((err) => {
                    console.log(err);
                });
        }, 800),

        /**
         * On click handle seller
         */
        selectPurchasedFromHandler(obj) {
            this.distributorObj = obj.item;
            this.form.distributor_id = obj.item.id;
        },

        selectSoldToHandler(obj) {
            this.customerObj = obj.item;
            this.form.customer_id = obj.item.id;
        },

        purchasedFromSuggestionsValue(obj) {
            return obj.item.company ? obj.item.company : obj.item.email;
        },

        soldToSuggestionsValue(obj) {
            //sold to is customer so always f name
            return obj.item.fname + ' - ' + obj.item.lname;
        },

        isEmpty(obj) {
            if (_.isEmpty(obj)) {
                return true;
            }
            return false;
        },
        showPdf() {
            this.va_showPdf(true);
            this.va_setPdfObj(this.product_detail);
        },
        ...mapActions({
            va_showPdf: 'pdf/setActive',
            va_setPdfObj: 'pdf/setActiveObj'
        })
    },

    beforeDestroy() {
        if (this.product_detail.sku_with_serial_number) {
            let channels = [];
            channels.push(this.product_detail.sku_with_serial_number);
            this.$pnUnsubscribe({channels: channels});
        }
        bus.$off('warranty-repair-box-refetch');
    }
};
</script>
